import axios from "axios";
import { useState } from "react";
import { EndPoints } from "../api";

export const useSubmitQuiz = () => {
  const [loading, setLoading] = useState(false);

  const submitQuiz = async (payload) => {
    setLoading(true);
    const tokenObj = JSON.parse(localStorage.getItem("learnableToken"));
    try {
      const res = await axios.patch(
        `${EndPoints.quiz}`,
        JSON.stringify({ answers: payload }),
        {
          headers: {
            "x-auth-token": tokenObj.token,
          },
        }
      );
      tokenObj.user_quiz = res.data.data;
      localStorage.setItem("learnableToken", JSON.stringify(tokenObj));
      return { data: res.data.data };
    } catch (error) {
      return { error: error?.response?.data?.message };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    submitQuiz,
  };
};
